import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Component, Inject, SecurityContext, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { first, tap } from 'rxjs/operators';

export interface DialogData_AddAtt {
  current_lang: string;
}

@Component({
  selector: 'app-add-attach',
  templateUrl: './add-attach.component.html',
  styleUrls: ['./add-attach.component.scss']
})
export class AddAttachComponent implements OnInit {
  attPlaceholder: string = '';

  att_name = '';
  dataurl_var = '';
  file_type = '';
  wrong_type = true;
  wrong_size = true;
  not_empty_src = false;
  src = '';

  loading = false;

  size = environment.sizeLimit;

  constructor(public dialogRef: MatDialogRef<AddAttachComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData_AddAtt,
              private sanitizer: DomSanitizer,
              private translate: TranslateService) {
    this.translate.onLangChange.subscribe(() => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.changeLangFunction(true);
  }

  changeLangFunction(isInit: boolean = false): void {
    this.translate.get('attachment.placeholder').pipe(
      first(),
      tap((res: string) => {
        this.attPlaceholder = res;
        if (isInit) {
          this.att_name = this.attPlaceholder;
        }
      })
    ).subscribe();
  }

  noNewAttach() {
    return this.att_name === this.attPlaceholder;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  inputChange(fileInputEvent: any) {
    this.loading = true;
    const file: File = fileInputEvent.target.files[0];
    this.att_name = file.name;

    const fileType = file.type;
    if (fileType.includes('image/')) {
      this.wrong_type = false;
      this.wrong_size = false;
      this.file_type = 'picture';
    } else if (fileType.includes('video/') && file.size <= this.size.video) {
      this.wrong_type = false;
      this.wrong_size = false;
      this.file_type = 'video';
    } else if (fileType.includes('video/') && file.size > this.size.video) {
      this.wrong_type = false;
      this.wrong_size = true;
      this.file_type = 'video';
      this.loading = false;
    } else if (fileType.includes('audio/')) {
      this.wrong_type = false;
      this.wrong_size = false;
      this.file_type = 'audio';
    } else if (fileType.includes('application/') || fileType.includes('text/')) {
      this.wrong_type = false;
      this.wrong_size = false;
      this.file_type = 'document';
    } else {
      this.wrong_type = true;
      this.wrong_size = false;
      this.loading = false;
    }

    if (!this.wrong_type && !this.wrong_size) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let url_supp = reader.result.toString();
        this.dataurl_var = this.sanitizer.sanitize(SecurityContext.URL, this.sanitizer.bypassSecurityTrustResourceUrl(url_supp));

        this.loading = false;
      };
    }
  }

  addSrc(event: Event) {
    this.src = (event.target as HTMLInputElement).value;
    if (this.src === '') {
      this.not_empty_src = false;
    } else {
      this.not_empty_src = true;
    }
  }

  newFile() {
    return {
        name: this.att_name,
        file_byte: this.dataurl_var,
        file_type: this.file_type,
        source: this.src,
        title_audio: false,
        avatar: false
    };
  }
}
